//登録フロー：登録完了・使い方ページ /newflow10
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import users from './store/user';
import {checkLogin} from './firebase'
import './css/newflow10.css';

export default class newflow10 extends Component {

  constructor() {
    super();
    this.state = {
      uid:''
    };
  }

  // onload
  componentDidMount() {
    var scope = this
    // ログインチェック
    checkLogin(true, function(isLogin){
      if (true === isLogin) {
        scope.setState({uid:users.getMyUser().uid})
      }
    })
  }

  render() {
    const {
      uid
    } = this.state

      return (
    <div id="wrapper">
      <div id="" className="wrapper-lp wrapper-newflow10">
        <Header parentProps={this.props} />
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <div className="block-newflow10">
                  <h2 className="title">Sign Up</h2>
                  <img className="title_icon" src="/img/common/img_check_purple.png" alt="" />
                  <p className="subtitle">登録が完了しました！</p>
                  <hr />
                  <div className="block__howTo">
                    <p className="title">MyRateの使い方</p>
                    <p className="subtitle">STEP1</p>
                    <p className="subtitle-ja">サービス連携をしよう</p>
                    <p className="contents">Records（実績）の＋マークからサービスを連携できます。</p>
                    <img className="step_1" src="/img/common/step1_lists.png" alt="" />

                    <p className="subtitle">STEP2</p>
                    <p className="subtitle-ja">MyRateランクを上げよう</p>
                    <p className="contents">サービスを連携したり、サービス内での実績を上げていくと、MyRateランクがアップします。ランクは全部で５段階あります。</p>
                    <img className="step_2" src="/img/common/step2_lists.png" alt="" />

                    <p className="subtitle">STEP3</p>
                    <p className="subtitle-ja">ライセンスをシェアして活用しよう</p>
                    <p className="contents">相手にライセンスをシェアし、自分の信用力を証明して取引の際に有効活用しましょう。</p>
                    <img className="step_3" src="/img/lp/img_service_2.png" alt="" />

                  </div>

                    <div className="btnAction">
                      <a href={`/user/${uid}`} className="btn-save">さっそくライセンスを見る</a>
                    </div>
                  
                </div>
              </div>
            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
      )

    }
}



// WEBPACK FOOTER //
// ./src/newflow10.js